
module.exports = function(){



    /*------------------------------------*\
        show/hide dropdown
    \*------------------------------------*/

    $('.js-filter-menu-toggle').on('click', function(event) {
        event.stopPropagation();

        if ($(this).hasClass('is-open')) {
            $(this).removeClass('is-open');
        } else {
            $('.js-filter-menu-toggle').removeClass('is-open');
            $(this).addClass('is-open');
        }

    });

    $(document).on('click', function(event) {
        $('.js-filter-menu-toggle').removeClass('is-open');
    });







    /*------------------------------------*\
        filter/sort items
    \*------------------------------------*/


    // init Isotope

    var shopIsoContainer = $('.js-shop-products-isotope');

    var ua = navigator.userAgent.toLowerCase();
    var Android = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    var shopIso = shopIsoContainer.isotope({
        itemSelector: '.js-isotope-item',
        //layoutMode: 'fitColumns',
        transitionDuration: (iOS || Android) ? 0 : 500,

        getSortData: {
            price: function( itemElem ) {
                var price = parseFloat( $( itemElem ).attr('data-price') );
                return price;
            }
        }
    });


    shopIsoContainer.find('img').each(function(index, el) {

        $(el).on('load', function(event) {
            //console.count('imgload');
            shopIsoContainer.isotope('layout');
        });

    });












    var gatherFilters = function(){

        var allFilters = [];

        var formColorValues = $('.js-filter-shop-color').serializeArray();
        var formCategoryValues = $('.js-filter-shop-category').serializeArray();
        var formPatternValues = $('.js-filter-shop-pattern').serializeArray();




        $(formColorValues).each(function(index, el) {

            if (el.value === '') {
                var filterSelector = el.value;
            } else {
                var filterSelector = '[data-color="' + el.value + '"]';
            }

            allFilters.push(filterSelector);
        });



        $(formCategoryValues).each(function(index, el) {

            if (el.value === '') {
                var filterSelector = el.value;
            } else {
                var filterSelector = '[data-category="' + el.value + '"]';
            }

            allFilters.push(filterSelector);
        });




        $(formPatternValues).each(function(index, el) {

            if (el.value === '') {
                var filterSelector = el.value;
            } else {
                var filterSelector = '[data-pattern="' + el.value + '"]';
            }

            allFilters.push(filterSelector);
        });


        //console.log(allFilters.join(''));
        return allFilters.join('');


    };






    $('.js-filter-shop-category input, .js-filter-shop-pattern input, .js-filter-shop-color input').on('change', function(event) {
        event.preventDefault();
        shopIsoContainer.isotope({ filter: gatherFilters() });
    });



    $('.js-filter-shop-price input').on('change', function(event) {

        var val = $(this).val();

        switch (val) {
            case 'Default':
                shopIsoContainer.isotope({ sortBy: 'original-order' });
                break;
            case 'HighToLow':
                shopIsoContainer.isotope({ sortBy: 'price', sortAscending: false });
                break;
            case 'LowToHigh':
                shopIsoContainer.isotope({ sortBy: 'price', sortAscending: true });
                break;
            default:
                shopIsoContainer.isotope({ sortBy: 'original-order' });
                break;
        }

    });





    /*--------------------------------------------------------*\
        only allow one filter at a time
    \*--------------------------------------------------------*/

    $('input[name="Price"]').on('change', function(event) {
        $('#AllColor').prop('checked', true);
        $('#AllPattern').prop('checked', true);
        $('body').trigger('click');
        shopIsoContainer.isotope({ filter: gatherFilters() });
    });

    $('input[name="FilterColor"]').on('change', function(event) {
        $('#Default').prop('checked', true);
        $('#AllPattern').prop('checked', true);
        $('body').trigger('click');
        shopIsoContainer.isotope({ filter: gatherFilters() });
    });

    $('input[name="FilterPattern"]').on('change', function(event) {
        $('#AllColor').prop('checked', true);
        $('#Default').prop('checked', true);
        $('body').trigger('click');
        shopIsoContainer.isotope({ filter: gatherFilters() });
    });








    /*--------------------------------------------------------*\
        if no items then hide filters
    \*--------------------------------------------------------*/


    /*------------------------------------*\
        get all filters values
    \*------------------------------------*/

    var filtersColors = {};
    var filtersPatterns = {};

    $('input[name="FilterColor"]').each(function(index, el) {
        filtersColors[ $(el).attr('value') ] = false;
    });
    $('input[name="FilterPattern"]').each(function(index, el) {
        filtersPatterns[ $(el).attr('value') ] = false;
    });



    /*------------------------------------*\
        check
    \*------------------------------------*/

    $('.js-isotope-item').each(function(index, el) {
        filtersColors[ $(el).attr('data-color') ] = true;
        filtersPatterns[ $(el).attr('data-pattern') ] = true;
    });


    /*------------------------------------*\
        which to hide?
    \*------------------------------------*/

    var colorsToHide = [];
    var patternsToHide = [];

    for (var i in filtersColors) {
        var color = filtersColors[i];
        if ( (!color) && (i!=="") ) {
            colorsToHide.push(i);
        }
    }

    for (var i in filtersPatterns) {
        var pattern = filtersPatterns[i];
        if ( (!pattern) && (i!=="") ) {
            patternsToHide.push(i);
        }
    }


    /*------------------------------------*\
        hide
    \*------------------------------------*/

    $(colorsToHide).each(function(index, el) {
        $('input[name="FilterColor"][value="'+el+'"]').closest('.js-filter-btn').hide();
    });

    $(patternsToHide).each(function(index, el) {
        $('input[name="FilterPattern"][value="'+el+'"]').closest('.js-filter-btn').hide();
    });




}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/filter.js